import { isJSON } from "../system/helper"

export class LocalStorage {
  static setItem(key: string, value: any) {
    if (value === undefined) {
      return null
    }
    try {
      // stringify objects only, no need to stringify strings or other primitives
      const serializedValue = (typeof value === 'object' && value !== null) ? JSON.stringify(value) : value
      localStorage.setItem(key, serializedValue)
    } catch (error) {
      console.error('Error saving to localStorage: ', error)
    }
  }

  static getItem(key: string) {
    try {
      const item = localStorage.getItem(key)
      if (item) {
        return isJSON(item) ? JSON.parse(item) : item
      }
      return null
    } catch (error) {
      console.error('Error reading from localStorage: ', error)
      return null
    }
  }

  static removeItem(key: string) {
    try {
      localStorage.removeItem(key)
      return key
    } catch (error) {
      console.error('Error removing from localStorage: ', error)
      return null
    }
  }
}
